import Vue from 'vue'
import CouponsOption from './coupons.vue'

const Coupons = Vue.extend(CouponsOption)

export function templateCouponsVue({ module, postMessage, callModule }) {
  const coupons = new Coupons({
    propsData: {
      module
    },
    methods: {
      postMessage,
      callModule
    }
  }).$mount()
  return coupons.$el
}
